/**
 * Dialog
 * Steuert das Öffnen und Schließen des Beratung-Dialogs.
 * Nutzt vorhandene DOM-Elemente und fügt keine Buttons dynamisch hinzu.
 */
export default class Dialog {
  /**
   * @param {HTMLElement} widget - Der gesamte Widget-Container
   * @param {HTMLElement} body - Der Body-Container für dynamische Inhalte
   * @param {HTMLElement} trigger - Button zum Öffnen des Dialogs
   * @param {HTMLElement} closeButton - Button zum Schließen des Dialogs
   */
  constructor(widget, body, trigger, closeButton) {
    this.widget = widget;
    this.body = body;
    this.trigger = trigger;
    this.closeButton = closeButton;
    this.isOpen = false;
    this.init();
  }

  /**
   * Initialisiert Eventlistener und Standardzustände.
   */
  init() {
    this.widget.classList.remove('is-open');
    this.closeButton.addEventListener('click', () => this.close());
  }

  /**
   * Öffnet den Dialog und aktiviert ggf. den Formularmodus.
   * @param {boolean} isFormDialog - Ob der Dialog im Formularmodus geöffnet wird.
   */
  open(isFormDialog = false) {
    this.widget.classList.add('is-open');

    if (isFormDialog) {
      this.widget.classList.add('content-element-advice--formdialog');
    } else {
      this.widget.classList.remove('content-element-advice--formdialog');
    }

    this.isOpen = true;
    this.body.setAttribute('aria-hidden', 'false');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.closeButton.setAttribute('aria-expanded', 'true');
  }

  /**
   * Schließt den Dialog, ohne Inhalte zu löschen.
   */
  close() {
    this.widget.classList.remove('is-open');
    this.widget.classList.remove('content-element-advice--formdialog');
    this.isOpen = false;
    this.body.setAttribute('aria-hidden', 'true');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.closeButton.setAttribute('aria-expanded', 'false');
  }
}
